import {LanguageType} from '@shared-types';

import {IFinder} from './user.preferences.finder.schema';

export type IUserPreferences = {
	language: LanguageType;
	notifyEmail: boolean;
	notifySMS: boolean;
	notifyWhatsapp: boolean;
	daysToReminder: number;
	penColor: string;
	penWidth: number;
	defaultCyclesFilter: DefaultCyclesFilterType;
	defaultStamp: number;
	showMetaTags: string[];
	viewedTutorials: string[];
	applyUserPreferences: boolean;
	finder: IFinder;
	tables: {[key: string]: string[]};
	dateFormat: string;
};

export enum DefaultCyclesFilterType {
	All = 'all',
	Empty = '',
	Lastweek = 'lastweek',
	Monthback = 'monthback',
}
